<template>
  <div class="kpi-withdraw-page">
    <van-tabs v-model="typeIndex" title-active-color="#3283fa" :line-width="60" color="#3283fa" :sticky="true" @change="setType">
      <van-tab v-for="type in types" :key="type.title" :title="type.title">
        <div v-if="typeIndex == 0">
          <div class="content">
            <div class="bottom-line">提现到账<span>微信</span></div>
            <div class="title">提现金额</div>
            <van-field v-model="params.amount" label="￥" label-width="50" type="number" placeholder="请输入提现金额" style="font-size:16px;"/>
            <div class="bottom-line tip">可提现余额{{info.availableMoney}}元</div>
          </div>
          <div class="btn">
            <van-button type="info" @click="onCreate">确认</van-button>
          </div>
        </div>

        <van-list v-if="typeIndex == 1" v-model="params.loading" :finished="params.finished" finished-text="— 暂无更多数据 —" class="list">
          <div v-for="(item, index) in params.list" :key="index" class="bottom-line flex-between item">
            <div>
              <div class="title">提现{{item.amount}}元</div>
              <div class="time">{{item.createTime}}</div>
            </div>
            <div v-if="item.status == 'no_pass'" class="status do"><van-icon name="info" /><span>提现失败</span></div>
            <div v-if="item.status == 'under_review'" class="status active"><van-icon name="clock" /><span>审核中</span></div>
            <div v-if="item.status == 'pass'" class="status done"><van-icon name="checked" /><span>提现成功</span></div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <back-home :activity_id="activity_id" :user_id="user_id" :kpi_uid="kpi_userid" :share_uid="share_userid"></back-home>

  </div>
</template>

<script>
import backHome from '../../components/back-home.vue';
export default {
  components: {
    backHome
  },
  data() {
    return {
      activity_id: localStorage.getItem('act_id'),
      user_id: localStorage.getItem('user_id'),
      kpi_userid: localStorage.getItem('kpi_user_id') || null,
      share_userid: localStorage.getItem('share_user_id') || null,
      typeIndex: 0,
      types: [
        { title: '申请提现' },
        { title: '提现记录' }
      ],
      info: {},
      params: {
        amount: null,
        loading: false,
        finished: false,
        list: [],
      },
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取信息
    getInfo(){
      this.$kpi.finance.getFinanceInfo().then(res=>{
        console.log(res)
        this.info = res;
      })
    },
    setType(index) {
      if (index == 1) {
        this.params.loading = false;
        this.params.finished = false;
        this.params.list = [];
        this.getRecord();
      }
    },
    getRecord() {
      this.params.loading = true;
      this.$kpi.finance.getWithdrawList().then(res => {
        this.params.loading = false;
        if(res.code==0){
          this.params.list = res.data;
          this.params.finished = true;
        }else if(res.code==10200){
          this.params.finished = true;
        }
      });
    },
    // 提交提现申请
    onCreate() {
      if (!this.params.amount) {
        return this.$toast('请输入提现金额');
      }
      if (Number(this.params.amount)<=0||Number(this.params.amount)>Number(this.info.availableMoney)) {
        return this.$toast('提现金额不能大于可提现金额');
      }
      if (Number(this.params.amount)<1) {
        return this.$toast('提现金额需大于1元');
      }
      this.$store.commit("setLoading", true);
      this.$kpi.finance.applyWithdraw({
        amount: Number(this.params.amount)
      }).then(res=>{
        this.$store.commit("setLoading", false);
        if(res.code==0&&res.data){
          this.params.amount = "";
          this.getInfo();
          this.$toast.success(res.data.msg||'提现成功');
        }
      })
    }
  }
};

</script>

<style lang="less" scoped>
.kpi-withdraw-page{
  .content {
    margin: 10px 0 30px;
    .bottom-line {
      padding: 10px 15px;
      background-color: #ffffff;
      span {
        margin-left: 30px;
        color: #5293fd;
      }
    }
    .tip {
      color: #b3b3b3;
    }
    .van-field__label {
      max-width: 25px;
      font-size: 24px;
      position: relative;
      top: 2px;
    }
    .van-cell {
      font-size: 16px;
    }
    .title {
      padding: 15px 15px 0;
      background-color: #ffffff;
    }
  }
  .btn {
    width: 100%;
    text-align: center;
    button {
      width: 90%;
    }
  }

  .list {
    margin-top: 10px;
    .item {
      background-color: #ffffff;
      padding: 7px 15px;
      .title {
        line-height: 30px;
        color: #333333;
      }
      .time {
        font-size: 12px;
        color: #999999;
      }
      .status {
        display: flex;
        align-items: center;
        .van-icon {
          font-size: 20px;
          margin-right: 5px;
        }
      }
    }
  }
}

</style>
